module.exports = __webpack_public_path__ + "img/cover_bookshelf.3cfe0ffe.png";